import { Divider, Grid, styled } from '@mui/material';
import React from 'react';
import { KpiText, KpiUiBase } from './common';
import { KpiUiTwoColumnOptions, KpiUiTwoColumnSection } from './types';

const TwoColumnTitle = styled(KpiText)`
  font-size: 1em;
`;

const TwoColumnMainValue = styled(KpiText)`
  font-size: 1.5em;
`;

const TwoColumnSubValue = styled(KpiText)`
  font-size: 0.8em;
`;

// Two column section component
const TwoColumnSection = ({ section }: { section: KpiUiTwoColumnSection }) => {
  return (
    <Grid
      item
      container
      direction={'column'}
      justifyContent={'flex-start'}
      wrap="nowrap"
      sx={{ height: '100%' }}
    >
      <Grid
        item
        container
        justifyContent={'center'}
        sx={{ minHeight: '1.5em', height: '1.5em' }}
      >
        {section.title ? (
          <TwoColumnTitle>{section.title}</TwoColumnTitle>
        ) : null}
      </Grid>
      <Grid
        item
        container
        direction={'column'}
        justifyContent="center"
        sx={{ flexGrow: 1, minHeight: 0 }}
      >
        <Grid item container justifyContent={'center'}>
          <TwoColumnMainValue>{section.mainValue}</TwoColumnMainValue>
        </Grid>
        {section.subValues && section.subValues.length > 0 ? (
          <Grid item container direction={'column'} alignItems={'center'}>
            {section.subValues.map((subValue, i) => (
              <Grid
                key={`${subValue.title}-${i}`}
                item
                container
                direction={'column'}
                alignItems={'center'}
                wrap={'nowrap'}
              >
                <TwoColumnSubValue>{subValue.title}</TwoColumnSubValue>
                <TwoColumnSubValue sx={{ flexShrink: 0 }}>
                  {subValue.value}
                </TwoColumnSubValue>
              </Grid>
            ))}
          </Grid>
        ) : null}
      </Grid>
    </Grid>
  );
};

export const KpiUiTwoColumn = (props: { options: KpiUiTwoColumnOptions }) => {
  const { options } = props;
  const { sections } = options;
  const { leftSection, rightSection } = sections;
  return (
    <KpiUiBase
      title={options.title}
      subtitle={options.subtitle}
      footer={options.footer}
      fontSize={options.fontSize}
    >
      <Grid
        item
        container
        direction="row"
        sx={{ flexGrow: 1, height: '100%' }}
        alignItems="center"
        wrap="nowrap"
      >
        <Grid
          item
          sx={{ flexGrow: 1, flexBasis: 0, height: '100%', minWidth: 0 }}
        >
          <TwoColumnSection section={leftSection} />
        </Grid>
        <Divider
          orientation="vertical"
          sx={{
            backgroundColor: '#ffffff',
            height: '80%',
            margin: '0 1rem',
          }}
        />
        <Grid
          item
          sx={{ flexGrow: 1, flexBasis: 0, height: '100%', minWidth: 0 }}
        >
          <TwoColumnSection section={rightSection} />
        </Grid>
      </Grid>
    </KpiUiBase>
  );
};
